import { AxiosResponse } from "axios";
import axiosClient from "@/services/api/index";

export default {
  getAppSettings(): Promise<AxiosResponse> {
    return axiosClient.get("app-settings");
  },
};
